import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useState } from "react";
import { toast } from "react-toastify";
import { InferType } from "yup";
import CreateCustomer from "../../components/Merchant/CreateCustomerForm";
import Modal from "../../components/Reusable/Modal";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { createUserValidationForm } from "../../utils/validationSchemas";

const CreateMerchantComponent = loadable(
  () => import("../../components/Merchant/CreateMerchant")
);

const CreateMerchant = () => {
  const [openUserFormPopup, setOpenUserFormPopup] = useState(false);
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false);
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["merchants"],
    navigateURL: "/",
  });

  const {
    mutateAsync: createCustomerMutateAsync,
    isPostLoading: createCustomerLoading,
  } = usePostHook({
    queryKey: ["customer"],
    navigateURL: null,
  });

  const { mutateAsync: createUser, isPostLoading: isuserloading } = usePostHook(
    {
      queryKey: ["user"],
      navigateURL: "",
    }
  );

  const generateRandomPassword = (length = 12) => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  };
  const handleCreateUser = async (values: any, setError: any) => {
    const url = `${APIS.USER}`;
    const randomPassword = generateRandomPassword();

    let formData = {
      ...values,
      password: randomPassword,
      confirm_password: randomPassword,
    };
    try {
      const res = await createUser({ url, formData, setError });
      if (res.status == 201) {
        setOpenUserFormPopup(!openUserFormPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleCreate = async (
    values: InferType<typeof createUserValidationForm>,
    setError: any
  ) => {
    const url = `${APIS.MERCHANT}`;
    const transformToId = (value: any) => {
      if (!value) return null;
      if (typeof value === "object" && "id" in value) return value.id;
      return value;
    };
    const formData = {
      ...values,
      user: transformToId(values.user),
      service_type: values?.service_type
        ? values?.service_type?.map((item) => item?.value)
        : [],
      payment_method: values?.payment_method
        ? values?.payment_method?.map((item) => item?.value)
        : [],
      product_type: values?.product_type
        ? values?.product_type?.map((item) => item?.value)
        : [],
      service_city: values?.service_city
        ? values?.service_city?.map((item) => item?.value)
        : [],
      service_branch: values?.service_branch
        ? values?.service_branch?.map((item) => item?.value)
        : [],
      st_charge: Number(values.st_charge),
    };
    console.log(formData);
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      toast.error(err);
      toast.error(err);
    }
  };

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;

    const formData = {
      ...values,
    };
    try {
      const res = await createCustomerMutateAsync({ url, formData, setError });
      if (res.status === 201) {
        setOpenAddReceiverPopup(false);
        setOpenAddSenderPopup(false);
      }
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Merchant
        </span>
      </div>
      <CreateMerchantComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        openAddReceiverPopup={openAddReceiverPopup}
        setOpenAddReceiverPopup={setOpenAddReceiverPopup}
        openAddSenderPopup={openAddSenderPopup}
        setOpenAddSenderPopup={setOpenAddSenderPopup}
        handleCreateUser={handleCreateUser}
        isuserloading={isuserloading}
        setOpenUserFormPopup={setOpenUserFormPopup}
        openUserFormPopup={openUserFormPopup}
      />
      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={
          <>
            <CreateCustomer
              handleCreate={handleCreateCustomer}
              isLoading={createCustomerLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={
          <>
            <CreateCustomer
              handleCreate={handleCreateCustomer}
              isLoading={createCustomerLoading}
            />
          </>
        }
      />
    </>
  );
};

export default CreateMerchant;
